












import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({
  components: {
  }
})
export default class ActButton extends Vue {
  @Prop({
    validator(value) {
      return ['red', 'orange', 'yellow', 'arrow', 'wire'].includes(value)
    },
  })
  type!: string

  @Prop({ default: false })
  disabled!: any

  @Prop()
  width!: string

  get className() {
    let disabled = ''
    if (this.disabled === 'over' || this.disabled === true || this.disabled === 1) {
      disabled = 'disabled'
    }
    return [this.type, disabled].filter(e => !!e).join(' ')
  }
  onClick() {
    const status = this.disabled
    const term = status === 'over' || status === 'unopen' || status === true || status === 1
    if (!term) {
      this.$emit('click')
    }
  }
}
